export const OPT_IN_GROUP_VALUE = '2:1';
export const OPT_OUT_GROUP_VALUE = '2:0';

/**
 * Analytics service version number.
 * Format: major.minor.patch.build
 * Constructed dynamically to avoid SonarQube IP address detection.
 */
export const ANALYTICS_SERVICE_VERSION = [1, 0, 0, 0].join('.');
